export function isInternalUrl(url: string): boolean {
    return /^\/(?!\/)/.test(url);
}
